import { METADATA_REQUIRED_ACTIONS } from '~/components/page/Automation/v2/components/Builder/constants/actions';
import type {
  ClientFlowAction,
  ClientFlowActionTrickle,
  ClientFlowActionWait,
} from '~/graphql/types.client';

export type RequiresMetadataActionType =
  | ClientFlowActionTrickle
  | ClientFlowActionWait;

const isMetadataRequiredAction = (
  action: ClientFlowAction,
): action is RequiresMetadataActionType =>
  METADATA_REQUIRED_ACTIONS.includes(action.__typename);

export default isMetadataRequiredAction;
